export default {"src":"/_next/static/media/super-arrow-right.91c5f42c.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};